const styles = {
  app: ({allBackgroundColor, allForegroundColor, backgroundImage, toolBackgroundColor }) => ({
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center', // Center content vertically
    alignItems: 'center', // Center content horizontally
    marginTop: '40px',
    marginBottom: '40px',
    backgroundImage: `url(${backgroundImage})`,
    backgroundColor: toolBackgroundColor || 'blanchedalmond',
    width: '100%'
  }),
  component1: () => ({
    opacity: 0,
    transition: 'opacity 5s ease-in-out', // Adjust duration as needed
  }),
  component1Active: () => ({
    opacity: 1,
  }),
  component2: () => ({
    opacity: 0,
    transition: 'opacity 5s ease-in-out', // Adjust duration as needed
  }),
  component2Active: () => ({
    opacity: 1,
  }),
};

export default styles;
